exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".broadcast[data-v-f5e1c022] {\n  max-height: 100vh;\n  overflow: hidden;\n  position: relative;\n}\n[data-v-f5e1c022] .broadcast .button-container {\n  position: relative;\n}\n.page-loading[data-v-f5e1c022] {\n  position: fixed;\n  left: calc(50% - 9px);\n  top: 55%;\n  z-index: 6;\n}\n", ""]);

// exports
